export default __webpack_public_path__ + "static/media/Nexus-1718803859403.fd141876.png";